import angular from 'angular';

(function () {
    'use strict';
    var core = angular.module('app.home');
    core.constant('GED_COMPONENTS', Object.freeze({
        BACKEND: 'BackEnd',
        FRONTEND: 'FrontEnd',
    }));
})();
